import * as React from 'react';
import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import logo from '../../assets/images/logo_white.png';
import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import Profile from '../profile/Profile.jsx';
import StyleOutlinedIcon from '@mui/icons-material/StyleOutlined';

import { useSelector } from 'react-redux';

export default function MenuAppBar() {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, setOpen] = useState(false);
    const user = useSelector((state) => state.user.data);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCloseSession = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    };

    return (
        <>
            <Profile open={open} setOpen={setOpen} />
            <Grid size={12}>
                <AppBar position="static">
                    <Toolbar >
                        <Typography sx={{ flexGrow: 1 }} >
                            <Box
                            component="img"
                            src={logo}
                            sx={{ height: { xs: 56, sm: 72, md: 100 }, width: 'auto' }}
                        />
                        </Typography>

                        <div>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                onClose={Boolean(anchorEl) ? handleClose : undefined}
                                open={Boolean(anchorEl)}
                            >
                                <MenuItem sx={{ fontSize: '20px' }} onClick={() => setOpen(true)}>Perfil</MenuItem>
                                <MenuItem sx={{ fontSize: '20px' }} onClick={handleCloseSession}>Cerrar sesión</MenuItem>
                            </Menu>

                            {/* Badge de versión — oculto en móvil */}
                            <Box
                                sx={{
                                    display: { xs: 'none', sm: 'inline-flex' },
                                    alignItems: 'center',
                                    color: 'white',
                                    mr: 3,
                                    opacity: 0.8,
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    padding: '4px 12px',
                                    borderRadius: '20px'
                                }}
                            >
                                <StyleOutlinedIcon sx={{ fontSize: 20, mr: 1 }} />
                                <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    v0.1.1
                                </Typography>
                            </Box>
                        </div>
                        <div>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="inherit"
                            >
                                {

                                    user.length > 0 ?
                                        <Avatar sx={{ bgcolor: "#0080ffff", border: '2px solid #ffffffce', width: { xs: 40, md: 60 }, height: { xs: 40, md: 60 }, fontSize: { xs: '22px', md: '35px' }, boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' }}>
                                            {user[0].name?.slice(0, 2).toUpperCase()}
                                        </Avatar>
                                        :
                                        <Avatar sx={{ bgcolor: "#0080ffff", border: '2px solid #ffffffce', width: { xs: 40, md: 60 }, height: { xs: 40, md: 60 }, fontSize: { xs: '22px', md: '35px' }, boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' }}>
                                            ?
                                        </Avatar>
                                }
                            </IconButton>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                onClose={Boolean(anchorEl) ? handleClose : undefined}
                                open={Boolean(anchorEl)}
                            >
                                <MenuItem sx={{ fontSize: '20px' }} onClick={() => setOpen(true)}>Perfil</MenuItem>
                                <MenuItem sx={{ fontSize: '20px' }} onClick={handleCloseSession}>Cerrar sesión</MenuItem>
                            </Menu>
                        </div>
                    </Toolbar>
                </AppBar>
            </Grid>
        </>

    );
}
